import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from './login.module.scss';
import { Button } from '@mui/material';
import { setToken, loginIdentityServer } from '../../store/features/userSlice';
import AtomicSpinner from 'atomic-spinner';
import Registration from './registration';
import withNotify from "../../component/_HighOrder/withNotify";

const Login = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [userLogged, setUserLogged] = useState('');
    const [userRegistered, setUserRegistered] = useState(false);
    const token = useSelector((state) => state.user.token);
    const [register, setRegister] = useState(false);
    const [loginForm, setLoginForm] = useState({ username: '', password: '' });

    useEffect(() => {
        if (userRegistered)
            props.notify.success('New User Successfully Registered!');
    }, [userRegistered]);

    const onSubmit = (event) => {
        event.preventDefault();

        if (!loginForm.username)
            return props.notify.error('Username is Required!');;
        if (!loginForm.password)
            return props.notify.error('Password is Required!');

        setLoading(true);

        dispatch(loginIdentityServer({
            loginForm,
            callback: (data) => {
                dispatch(setToken(data.access_token));
                setLoading(false);
                setUserLogged('You were logged into the system');
                props.notify.success('You were logged into the system');
                setLoginForm({ username: '', password: '' });
            },
            catch: (error) => {
                console.log('Error during token exchange:', error);
                props.notify.error('Error during login');
                setLoading(false);
            }
        }));
    };

    const onLogout = (event) => {
        event.preventDefault();

        dispatch(setToken(''));

        props.notify.success('You were logged out');
    };

    return (
        loading ? <div className={styles.atomicSpiner}><AtomicSpinner /></div>
            :
            register === true ?
                <Registration setRegister={setRegister} setUserRegistered={setUserRegistered} />
                :
                <form onSubmit={(event) => onSubmit(event)}>
                    <div className={styles.practitionerDiv}>
                        {
                            token ?
                                <>
                                    <h2>Account</h2>
                                    <h3>{userLogged}</h3>
                                    <Button type='submit' variant="contained" onClick={(event) => onLogout(event)}>
                                        Logout
                                    </Button>
                                </>
                                :
                                <>
                                    <h2>Login</h2>
                                    {userRegistered && <h3>New User Successfully Registered!</h3>}

                                    <div className={styles.loginDiv}>
                                        <input type="text" placeholder="Username" className={styles.loginInput} value={loginForm.username} onChange={(event) => setLoginForm({ ...loginForm, username: event.target.value })}></input>
                                    </div>
                                    <div className={styles.loginDiv}>
                                        <input type="password" placeholder="Password" className={styles.loginInput} value={loginForm.password} onChange={(event) => setLoginForm({ ...loginForm, password: event.target.value })}></input>
                                    </div>
                                    <Button type='submit' variant="contained" onClick={(event) => onSubmit(event)}>
                                        Sign in
                                    </Button>
                                    <div className={styles.registerDiv}>
                                        <p>If you are not registered yet</p>
                                        <button className={styles.filterBtn} onClick={() => setRegister(true)}>Register here!</button>
                                    </div>
                                </>
                        }
                    </div>
                </form>
    );
};

export default withNotify(Login);